export default "__VITE_ASSET__Bnl56VTo__"